// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v3.12.4
// source: aurora/filter.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "biggeo.aurora";

export enum OrderByOptions {
  ASC = 0,
  DESC = 1,
  UNRECOGNIZED = -1,
}

export function orderByOptionsFromJSON(object: any): OrderByOptions {
  switch (object) {
    case 0:
    case "ASC":
      return OrderByOptions.ASC;
    case 1:
    case "DESC":
      return OrderByOptions.DESC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrderByOptions.UNRECOGNIZED;
  }
}

export function orderByOptionsToJSON(object: OrderByOptions): string {
  switch (object) {
    case OrderByOptions.ASC:
      return "ASC";
    case OrderByOptions.DESC:
      return "DESC";
    case OrderByOptions.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DatabaseType {
  POINT = 0,
  POLYGON = 1,
  UNRECOGNIZED = -1,
}

export function databaseTypeFromJSON(object: any): DatabaseType {
  switch (object) {
    case 0:
    case "POINT":
      return DatabaseType.POINT;
    case 1:
    case "POLYGON":
      return DatabaseType.POLYGON;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DatabaseType.UNRECOGNIZED;
  }
}

export function databaseTypeToJSON(object: DatabaseType): string {
  switch (object) {
    case DatabaseType.POINT:
      return "POINT";
    case DatabaseType.POLYGON:
      return "POLYGON";
    case DatabaseType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WhereOperator {
  CONTAINS = 0,
  EQUALS = 1,
  STARTS_WITH = 2,
  ENDS_WITH = 3,
  IS_EMPTY = 4,
  IS_NOT_EMPTY = 5,
  IS_ANY_OF = 6,
  EQ = 7,
  NEQ = 8,
  LT = 9,
  LTE = 10,
  GT = 11,
  GTE = 12,
  NONE = 13,
  IS = 14,
  UNRECOGNIZED = -1,
}

export function whereOperatorFromJSON(object: any): WhereOperator {
  switch (object) {
    case 0:
    case "CONTAINS":
      return WhereOperator.CONTAINS;
    case 1:
    case "EQUALS":
      return WhereOperator.EQUALS;
    case 2:
    case "STARTS_WITH":
      return WhereOperator.STARTS_WITH;
    case 3:
    case "ENDS_WITH":
      return WhereOperator.ENDS_WITH;
    case 4:
    case "IS_EMPTY":
      return WhereOperator.IS_EMPTY;
    case 5:
    case "IS_NOT_EMPTY":
      return WhereOperator.IS_NOT_EMPTY;
    case 6:
    case "IS_ANY_OF":
      return WhereOperator.IS_ANY_OF;
    case 7:
    case "EQ":
      return WhereOperator.EQ;
    case 8:
    case "NEQ":
      return WhereOperator.NEQ;
    case 9:
    case "LT":
      return WhereOperator.LT;
    case 10:
    case "LTE":
      return WhereOperator.LTE;
    case 11:
    case "GT":
      return WhereOperator.GT;
    case 12:
    case "GTE":
      return WhereOperator.GTE;
    case 13:
    case "NONE":
      return WhereOperator.NONE;
    case 14:
    case "IS":
      return WhereOperator.IS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WhereOperator.UNRECOGNIZED;
  }
}

export function whereOperatorToJSON(object: WhereOperator): string {
  switch (object) {
    case WhereOperator.CONTAINS:
      return "CONTAINS";
    case WhereOperator.EQUALS:
      return "EQUALS";
    case WhereOperator.STARTS_WITH:
      return "STARTS_WITH";
    case WhereOperator.ENDS_WITH:
      return "ENDS_WITH";
    case WhereOperator.IS_EMPTY:
      return "IS_EMPTY";
    case WhereOperator.IS_NOT_EMPTY:
      return "IS_NOT_EMPTY";
    case WhereOperator.IS_ANY_OF:
      return "IS_ANY_OF";
    case WhereOperator.EQ:
      return "EQ";
    case WhereOperator.NEQ:
      return "NEQ";
    case WhereOperator.LT:
      return "LT";
    case WhereOperator.LTE:
      return "LTE";
    case WhereOperator.GT:
      return "GT";
    case WhereOperator.GTE:
      return "GTE";
    case WhereOperator.NONE:
      return "NONE";
    case WhereOperator.IS:
      return "IS";
    case WhereOperator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FilterType {
  StringType = 0,
  NumberType = 1,
  DateType = 2,
  BooleanType = 3,
  UNRECOGNIZED = -1,
}

export function filterTypeFromJSON(object: any): FilterType {
  switch (object) {
    case 0:
    case "StringType":
      return FilterType.StringType;
    case 1:
    case "NumberType":
      return FilterType.NumberType;
    case 2:
    case "DateType":
      return FilterType.DateType;
    case 3:
    case "BooleanType":
      return FilterType.BooleanType;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FilterType.UNRECOGNIZED;
  }
}

export function filterTypeToJSON(object: FilterType): string {
  switch (object) {
    case FilterType.StringType:
      return "StringType";
    case FilterType.NumberType:
      return "NumberType";
    case FilterType.DateType:
      return "DateType";
    case FilterType.BooleanType:
      return "BooleanType";
    case FilterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum LogicOperator {
  AND = 0,
  OR = 1,
  UNRECOGNIZED = -1,
}

export function logicOperatorFromJSON(object: any): LogicOperator {
  switch (object) {
    case 0:
    case "AND":
      return LogicOperator.AND;
    case 1:
    case "OR":
      return LogicOperator.OR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LogicOperator.UNRECOGNIZED;
  }
}

export function logicOperatorToJSON(object: LogicOperator): string {
  switch (object) {
    case LogicOperator.AND:
      return "AND";
    case LogicOperator.OR:
      return "OR";
    case LogicOperator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface FilterData {
  stringData?: string | undefined;
  numberData?: number | undefined;
  dateData?: Date | undefined;
  booleanData?: boolean | undefined;
}

export interface FilterItem {
  id?: string | undefined;
  type: FilterType;
  column: string;
  data: FilterData | undefined;
  operator: WhereOperator;
}

export interface FilterObject {
  organizationId: string;
  databaseId: string;
  filters: FilterItem[];
  logicOperator: LogicOperator;
  collection: string;
  databaseType: DatabaseType;
  isPreview?: boolean | undefined;
  options?: RequestOptions | undefined;
  limitOffset?: LimitOffset | undefined;
  idColumn: string;
}

export interface LimitOffset {
  limit: number;
  offset: number;
}

export interface RequestOptions {
  pointMaxGeomsPerCell?: number | undefined;
  pointResolutionOffset?: number | undefined;
  polygonMaxGeomsPerCell?: number | undefined;
  polygonResolutionOffset?: number | undefined;
  geometriesChunkSize?: number | undefined;
  aggregatesChunkSize?: number | undefined;
  maxAdditionalRefines?: number | undefined;
  levelSets: number[];
}

export interface OrderBy {
  column: string;
  order: OrderByOptions;
}

export interface InputPoint {
  latitude: number;
  longitude: number;
}

export interface InputRadius {
  center: InputPoint | undefined;
  radiusKm: number;
}

export interface InputPolygon {
  outer: InputRing | undefined;
  inners: InputRing[];
  properties?: InputPolygonProperties | undefined;
}

export interface InputRing {
  points: InputPoint[];
}

export interface InputPolygonProperties {
  name?: string | undefined;
  fill?: InputPolygonColor | undefined;
  stroke?: InputPolygonColor | undefined;
  areadId?: number | undefined;
  savedAreadId?: number | undefined;
}

export interface InputBounds {
  min: number;
  max: number;
}

export interface InputViewBox {
  latBounds: InputBounds | undefined;
  lngBounds: InputBounds | undefined;
}

export interface InputPolygonColor {
  color: string;
  opacity: number;
}

function createBaseFilterData(): FilterData {
  return { stringData: undefined, numberData: undefined, dateData: undefined, booleanData: undefined };
}

export const FilterData: MessageFns<FilterData> = {
  encode(message: FilterData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stringData !== undefined) {
      writer.uint32(10).string(message.stringData);
    }
    if (message.numberData !== undefined) {
      writer.uint32(21).float(message.numberData);
    }
    if (message.dateData !== undefined) {
      Timestamp.encode(toTimestamp(message.dateData), writer.uint32(26).fork()).join();
    }
    if (message.booleanData !== undefined) {
      writer.uint32(32).bool(message.booleanData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stringData = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.numberData = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dateData = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.booleanData = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FilterData {
    return {
      stringData: isSet(object.stringData) ? globalThis.String(object.stringData) : undefined,
      numberData: isSet(object.numberData) ? globalThis.Number(object.numberData) : undefined,
      dateData: isSet(object.dateData) ? fromJsonTimestamp(object.dateData) : undefined,
      booleanData: isSet(object.booleanData) ? globalThis.Boolean(object.booleanData) : undefined,
    };
  },

  toJSON(message: FilterData): unknown {
    const obj: any = {};
    if (message.stringData !== undefined) {
      obj.stringData = message.stringData;
    }
    if (message.numberData !== undefined) {
      obj.numberData = message.numberData;
    }
    if (message.dateData !== undefined) {
      obj.dateData = message.dateData.toISOString();
    }
    if (message.booleanData !== undefined) {
      obj.booleanData = message.booleanData;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterData>, I>>(base?: I): FilterData {
    return FilterData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterData>, I>>(object: I): FilterData {
    const message = createBaseFilterData();
    message.stringData = object.stringData ?? undefined;
    message.numberData = object.numberData ?? undefined;
    message.dateData = object.dateData ?? undefined;
    message.booleanData = object.booleanData ?? undefined;
    return message;
  },
};

function createBaseFilterItem(): FilterItem {
  return { id: undefined, type: 0, column: "", data: undefined, operator: 0 };
}

export const FilterItem: MessageFns<FilterItem> = {
  encode(message: FilterItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.column !== "") {
      writer.uint32(26).string(message.column);
    }
    if (message.data !== undefined) {
      FilterData.encode(message.data, writer.uint32(34).fork()).join();
    }
    if (message.operator !== 0) {
      writer.uint32(40).int32(message.operator);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.column = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.data = FilterData.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.operator = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FilterItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      type: isSet(object.type) ? filterTypeFromJSON(object.type) : 0,
      column: isSet(object.column) ? globalThis.String(object.column) : "",
      data: isSet(object.data) ? FilterData.fromJSON(object.data) : undefined,
      operator: isSet(object.operator) ? whereOperatorFromJSON(object.operator) : 0,
    };
  },

  toJSON(message: FilterItem): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.type !== 0) {
      obj.type = filterTypeToJSON(message.type);
    }
    if (message.column !== "") {
      obj.column = message.column;
    }
    if (message.data !== undefined) {
      obj.data = FilterData.toJSON(message.data);
    }
    if (message.operator !== 0) {
      obj.operator = whereOperatorToJSON(message.operator);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterItem>, I>>(base?: I): FilterItem {
    return FilterItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterItem>, I>>(object: I): FilterItem {
    const message = createBaseFilterItem();
    message.id = object.id ?? undefined;
    message.type = object.type ?? 0;
    message.column = object.column ?? "";
    message.data = (object.data !== undefined && object.data !== null)
      ? FilterData.fromPartial(object.data)
      : undefined;
    message.operator = object.operator ?? 0;
    return message;
  },
};

function createBaseFilterObject(): FilterObject {
  return {
    organizationId: "",
    databaseId: "",
    filters: [],
    logicOperator: 0,
    collection: "",
    databaseType: 0,
    isPreview: undefined,
    options: undefined,
    limitOffset: undefined,
    idColumn: "",
  };
}

export const FilterObject: MessageFns<FilterObject> = {
  encode(message: FilterObject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organizationId !== "") {
      writer.uint32(10).string(message.organizationId);
    }
    if (message.databaseId !== "") {
      writer.uint32(18).string(message.databaseId);
    }
    for (const v of message.filters) {
      FilterItem.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.logicOperator !== 0) {
      writer.uint32(32).int32(message.logicOperator);
    }
    if (message.collection !== "") {
      writer.uint32(42).string(message.collection);
    }
    if (message.databaseType !== 0) {
      writer.uint32(48).int32(message.databaseType);
    }
    if (message.isPreview !== undefined) {
      writer.uint32(56).bool(message.isPreview);
    }
    if (message.options !== undefined) {
      RequestOptions.encode(message.options, writer.uint32(66).fork()).join();
    }
    if (message.limitOffset !== undefined) {
      LimitOffset.encode(message.limitOffset, writer.uint32(74).fork()).join();
    }
    if (message.idColumn !== "") {
      writer.uint32(82).string(message.idColumn);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterObject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.databaseId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.filters.push(FilterItem.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.logicOperator = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.databaseType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isPreview = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.options = RequestOptions.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.limitOffset = LimitOffset.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.idColumn = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FilterObject {
    return {
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      databaseId: isSet(object.databaseId) ? globalThis.String(object.databaseId) : "",
      filters: globalThis.Array.isArray(object?.filters) ? object.filters.map((e: any) => FilterItem.fromJSON(e)) : [],
      logicOperator: isSet(object.logicOperator) ? logicOperatorFromJSON(object.logicOperator) : 0,
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
      databaseType: isSet(object.databaseType) ? databaseTypeFromJSON(object.databaseType) : 0,
      isPreview: isSet(object.isPreview) ? globalThis.Boolean(object.isPreview) : undefined,
      options: isSet(object.options) ? RequestOptions.fromJSON(object.options) : undefined,
      limitOffset: isSet(object.limitOffset) ? LimitOffset.fromJSON(object.limitOffset) : undefined,
      idColumn: isSet(object.idColumn) ? globalThis.String(object.idColumn) : "",
    };
  },

  toJSON(message: FilterObject): unknown {
    const obj: any = {};
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.databaseId !== "") {
      obj.databaseId = message.databaseId;
    }
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => FilterItem.toJSON(e));
    }
    if (message.logicOperator !== 0) {
      obj.logicOperator = logicOperatorToJSON(message.logicOperator);
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    if (message.databaseType !== 0) {
      obj.databaseType = databaseTypeToJSON(message.databaseType);
    }
    if (message.isPreview !== undefined) {
      obj.isPreview = message.isPreview;
    }
    if (message.options !== undefined) {
      obj.options = RequestOptions.toJSON(message.options);
    }
    if (message.limitOffset !== undefined) {
      obj.limitOffset = LimitOffset.toJSON(message.limitOffset);
    }
    if (message.idColumn !== "") {
      obj.idColumn = message.idColumn;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterObject>, I>>(base?: I): FilterObject {
    return FilterObject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterObject>, I>>(object: I): FilterObject {
    const message = createBaseFilterObject();
    message.organizationId = object.organizationId ?? "";
    message.databaseId = object.databaseId ?? "";
    message.filters = object.filters?.map((e) => FilterItem.fromPartial(e)) || [];
    message.logicOperator = object.logicOperator ?? 0;
    message.collection = object.collection ?? "";
    message.databaseType = object.databaseType ?? 0;
    message.isPreview = object.isPreview ?? undefined;
    message.options = (object.options !== undefined && object.options !== null)
      ? RequestOptions.fromPartial(object.options)
      : undefined;
    message.limitOffset = (object.limitOffset !== undefined && object.limitOffset !== null)
      ? LimitOffset.fromPartial(object.limitOffset)
      : undefined;
    message.idColumn = object.idColumn ?? "";
    return message;
  },
};

function createBaseLimitOffset(): LimitOffset {
  return { limit: 0, offset: 0 };
}

export const LimitOffset: MessageFns<LimitOffset> = {
  encode(message: LimitOffset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limit !== 0) {
      writer.uint32(8).int32(message.limit);
    }
    if (message.offset !== 0) {
      writer.uint32(16).int32(message.offset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LimitOffset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLimitOffset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.offset = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LimitOffset {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
    };
  },

  toJSON(message: LimitOffset): unknown {
    const obj: any = {};
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LimitOffset>, I>>(base?: I): LimitOffset {
    return LimitOffset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LimitOffset>, I>>(object: I): LimitOffset {
    const message = createBaseLimitOffset();
    message.limit = object.limit ?? 0;
    message.offset = object.offset ?? 0;
    return message;
  },
};

function createBaseRequestOptions(): RequestOptions {
  return {
    pointMaxGeomsPerCell: undefined,
    pointResolutionOffset: undefined,
    polygonMaxGeomsPerCell: undefined,
    polygonResolutionOffset: undefined,
    geometriesChunkSize: undefined,
    aggregatesChunkSize: undefined,
    maxAdditionalRefines: undefined,
    levelSets: [],
  };
}

export const RequestOptions: MessageFns<RequestOptions> = {
  encode(message: RequestOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pointMaxGeomsPerCell !== undefined) {
      writer.uint32(8).int32(message.pointMaxGeomsPerCell);
    }
    if (message.pointResolutionOffset !== undefined) {
      writer.uint32(16).int32(message.pointResolutionOffset);
    }
    if (message.polygonMaxGeomsPerCell !== undefined) {
      writer.uint32(24).int32(message.polygonMaxGeomsPerCell);
    }
    if (message.polygonResolutionOffset !== undefined) {
      writer.uint32(32).int32(message.polygonResolutionOffset);
    }
    if (message.geometriesChunkSize !== undefined) {
      writer.uint32(40).int32(message.geometriesChunkSize);
    }
    if (message.aggregatesChunkSize !== undefined) {
      writer.uint32(48).int32(message.aggregatesChunkSize);
    }
    if (message.maxAdditionalRefines !== undefined) {
      writer.uint32(56).int32(message.maxAdditionalRefines);
    }
    writer.uint32(66).fork();
    for (const v of message.levelSets) {
      writer.float(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pointMaxGeomsPerCell = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pointResolutionOffset = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.polygonMaxGeomsPerCell = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.polygonResolutionOffset = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.geometriesChunkSize = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.aggregatesChunkSize = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxAdditionalRefines = reader.int32();
          continue;
        }
        case 8: {
          if (tag === 69) {
            message.levelSets.push(reader.float());

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.levelSets.push(reader.float());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestOptions {
    return {
      pointMaxGeomsPerCell: isSet(object.pointMaxGeomsPerCell)
        ? globalThis.Number(object.pointMaxGeomsPerCell)
        : undefined,
      pointResolutionOffset: isSet(object.pointResolutionOffset)
        ? globalThis.Number(object.pointResolutionOffset)
        : undefined,
      polygonMaxGeomsPerCell: isSet(object.polygonMaxGeomsPerCell)
        ? globalThis.Number(object.polygonMaxGeomsPerCell)
        : undefined,
      polygonResolutionOffset: isSet(object.polygonResolutionOffset)
        ? globalThis.Number(object.polygonResolutionOffset)
        : undefined,
      geometriesChunkSize: isSet(object.geometriesChunkSize)
        ? globalThis.Number(object.geometriesChunkSize)
        : undefined,
      aggregatesChunkSize: isSet(object.aggregatesChunkSize)
        ? globalThis.Number(object.aggregatesChunkSize)
        : undefined,
      maxAdditionalRefines: isSet(object.maxAdditionalRefines)
        ? globalThis.Number(object.maxAdditionalRefines)
        : undefined,
      levelSets: globalThis.Array.isArray(object?.levelSets)
        ? object.levelSets.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: RequestOptions): unknown {
    const obj: any = {};
    if (message.pointMaxGeomsPerCell !== undefined) {
      obj.pointMaxGeomsPerCell = Math.round(message.pointMaxGeomsPerCell);
    }
    if (message.pointResolutionOffset !== undefined) {
      obj.pointResolutionOffset = Math.round(message.pointResolutionOffset);
    }
    if (message.polygonMaxGeomsPerCell !== undefined) {
      obj.polygonMaxGeomsPerCell = Math.round(message.polygonMaxGeomsPerCell);
    }
    if (message.polygonResolutionOffset !== undefined) {
      obj.polygonResolutionOffset = Math.round(message.polygonResolutionOffset);
    }
    if (message.geometriesChunkSize !== undefined) {
      obj.geometriesChunkSize = Math.round(message.geometriesChunkSize);
    }
    if (message.aggregatesChunkSize !== undefined) {
      obj.aggregatesChunkSize = Math.round(message.aggregatesChunkSize);
    }
    if (message.maxAdditionalRefines !== undefined) {
      obj.maxAdditionalRefines = Math.round(message.maxAdditionalRefines);
    }
    if (message.levelSets?.length) {
      obj.levelSets = message.levelSets;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestOptions>, I>>(base?: I): RequestOptions {
    return RequestOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestOptions>, I>>(object: I): RequestOptions {
    const message = createBaseRequestOptions();
    message.pointMaxGeomsPerCell = object.pointMaxGeomsPerCell ?? undefined;
    message.pointResolutionOffset = object.pointResolutionOffset ?? undefined;
    message.polygonMaxGeomsPerCell = object.polygonMaxGeomsPerCell ?? undefined;
    message.polygonResolutionOffset = object.polygonResolutionOffset ?? undefined;
    message.geometriesChunkSize = object.geometriesChunkSize ?? undefined;
    message.aggregatesChunkSize = object.aggregatesChunkSize ?? undefined;
    message.maxAdditionalRefines = object.maxAdditionalRefines ?? undefined;
    message.levelSets = object.levelSets?.map((e) => e) || [];
    return message;
  },
};

function createBaseOrderBy(): OrderBy {
  return { column: "", order: 0 };
}

export const OrderBy: MessageFns<OrderBy> = {
  encode(message: OrderBy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column !== "") {
      writer.uint32(10).string(message.column);
    }
    if (message.order !== 0) {
      writer.uint32(16).int32(message.order);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderBy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderBy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.order = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderBy {
    return {
      column: isSet(object.column) ? globalThis.String(object.column) : "",
      order: isSet(object.order) ? orderByOptionsFromJSON(object.order) : 0,
    };
  },

  toJSON(message: OrderBy): unknown {
    const obj: any = {};
    if (message.column !== "") {
      obj.column = message.column;
    }
    if (message.order !== 0) {
      obj.order = orderByOptionsToJSON(message.order);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderBy>, I>>(base?: I): OrderBy {
    return OrderBy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderBy>, I>>(object: I): OrderBy {
    const message = createBaseOrderBy();
    message.column = object.column ?? "";
    message.order = object.order ?? 0;
    return message;
  },
};

function createBaseInputPoint(): InputPoint {
  return { latitude: 0, longitude: 0 };
}

export const InputPoint: MessageFns<InputPoint> = {
  encode(message: InputPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== 0) {
      writer.uint32(13).float(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(21).float(message.longitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.latitude = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.longitude = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputPoint {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
    };
  },

  toJSON(message: InputPoint): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputPoint>, I>>(base?: I): InputPoint {
    return InputPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputPoint>, I>>(object: I): InputPoint {
    const message = createBaseInputPoint();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    return message;
  },
};

function createBaseInputRadius(): InputRadius {
  return { center: undefined, radiusKm: 0 };
}

export const InputRadius: MessageFns<InputRadius> = {
  encode(message: InputRadius, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.center !== undefined) {
      InputPoint.encode(message.center, writer.uint32(10).fork()).join();
    }
    if (message.radiusKm !== 0) {
      writer.uint32(21).float(message.radiusKm);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputRadius {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputRadius();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.center = InputPoint.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.radiusKm = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputRadius {
    return {
      center: isSet(object.center) ? InputPoint.fromJSON(object.center) : undefined,
      radiusKm: isSet(object.radiusKm) ? globalThis.Number(object.radiusKm) : 0,
    };
  },

  toJSON(message: InputRadius): unknown {
    const obj: any = {};
    if (message.center !== undefined) {
      obj.center = InputPoint.toJSON(message.center);
    }
    if (message.radiusKm !== 0) {
      obj.radiusKm = message.radiusKm;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputRadius>, I>>(base?: I): InputRadius {
    return InputRadius.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputRadius>, I>>(object: I): InputRadius {
    const message = createBaseInputRadius();
    message.center = (object.center !== undefined && object.center !== null)
      ? InputPoint.fromPartial(object.center)
      : undefined;
    message.radiusKm = object.radiusKm ?? 0;
    return message;
  },
};

function createBaseInputPolygon(): InputPolygon {
  return { outer: undefined, inners: [], properties: undefined };
}

export const InputPolygon: MessageFns<InputPolygon> = {
  encode(message: InputPolygon, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outer !== undefined) {
      InputRing.encode(message.outer, writer.uint32(10).fork()).join();
    }
    for (const v of message.inners) {
      InputRing.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.properties !== undefined) {
      InputPolygonProperties.encode(message.properties, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputPolygon {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputPolygon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.outer = InputRing.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.inners.push(InputRing.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.properties = InputPolygonProperties.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputPolygon {
    return {
      outer: isSet(object.outer) ? InputRing.fromJSON(object.outer) : undefined,
      inners: globalThis.Array.isArray(object?.inners) ? object.inners.map((e: any) => InputRing.fromJSON(e)) : [],
      properties: isSet(object.properties) ? InputPolygonProperties.fromJSON(object.properties) : undefined,
    };
  },

  toJSON(message: InputPolygon): unknown {
    const obj: any = {};
    if (message.outer !== undefined) {
      obj.outer = InputRing.toJSON(message.outer);
    }
    if (message.inners?.length) {
      obj.inners = message.inners.map((e) => InputRing.toJSON(e));
    }
    if (message.properties !== undefined) {
      obj.properties = InputPolygonProperties.toJSON(message.properties);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputPolygon>, I>>(base?: I): InputPolygon {
    return InputPolygon.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputPolygon>, I>>(object: I): InputPolygon {
    const message = createBaseInputPolygon();
    message.outer = (object.outer !== undefined && object.outer !== null)
      ? InputRing.fromPartial(object.outer)
      : undefined;
    message.inners = object.inners?.map((e) => InputRing.fromPartial(e)) || [];
    message.properties = (object.properties !== undefined && object.properties !== null)
      ? InputPolygonProperties.fromPartial(object.properties)
      : undefined;
    return message;
  },
};

function createBaseInputRing(): InputRing {
  return { points: [] };
}

export const InputRing: MessageFns<InputRing> = {
  encode(message: InputRing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      InputPoint.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputRing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputRing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.points.push(InputPoint.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputRing {
    return {
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => InputPoint.fromJSON(e)) : [],
    };
  },

  toJSON(message: InputRing): unknown {
    const obj: any = {};
    if (message.points?.length) {
      obj.points = message.points.map((e) => InputPoint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputRing>, I>>(base?: I): InputRing {
    return InputRing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputRing>, I>>(object: I): InputRing {
    const message = createBaseInputRing();
    message.points = object.points?.map((e) => InputPoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInputPolygonProperties(): InputPolygonProperties {
  return { name: undefined, fill: undefined, stroke: undefined, areadId: undefined, savedAreadId: undefined };
}

export const InputPolygonProperties: MessageFns<InputPolygonProperties> = {
  encode(message: InputPolygonProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.fill !== undefined) {
      InputPolygonColor.encode(message.fill, writer.uint32(18).fork()).join();
    }
    if (message.stroke !== undefined) {
      InputPolygonColor.encode(message.stroke, writer.uint32(26).fork()).join();
    }
    if (message.areadId !== undefined) {
      writer.uint32(32).int32(message.areadId);
    }
    if (message.savedAreadId !== undefined) {
      writer.uint32(40).int32(message.savedAreadId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputPolygonProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputPolygonProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fill = InputPolygonColor.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stroke = InputPolygonColor.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.areadId = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.savedAreadId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputPolygonProperties {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      fill: isSet(object.fill) ? InputPolygonColor.fromJSON(object.fill) : undefined,
      stroke: isSet(object.stroke) ? InputPolygonColor.fromJSON(object.stroke) : undefined,
      areadId: isSet(object.areadId) ? globalThis.Number(object.areadId) : undefined,
      savedAreadId: isSet(object.savedAreadId) ? globalThis.Number(object.savedAreadId) : undefined,
    };
  },

  toJSON(message: InputPolygonProperties): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.fill !== undefined) {
      obj.fill = InputPolygonColor.toJSON(message.fill);
    }
    if (message.stroke !== undefined) {
      obj.stroke = InputPolygonColor.toJSON(message.stroke);
    }
    if (message.areadId !== undefined) {
      obj.areadId = Math.round(message.areadId);
    }
    if (message.savedAreadId !== undefined) {
      obj.savedAreadId = Math.round(message.savedAreadId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputPolygonProperties>, I>>(base?: I): InputPolygonProperties {
    return InputPolygonProperties.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputPolygonProperties>, I>>(object: I): InputPolygonProperties {
    const message = createBaseInputPolygonProperties();
    message.name = object.name ?? undefined;
    message.fill = (object.fill !== undefined && object.fill !== null)
      ? InputPolygonColor.fromPartial(object.fill)
      : undefined;
    message.stroke = (object.stroke !== undefined && object.stroke !== null)
      ? InputPolygonColor.fromPartial(object.stroke)
      : undefined;
    message.areadId = object.areadId ?? undefined;
    message.savedAreadId = object.savedAreadId ?? undefined;
    return message;
  },
};

function createBaseInputBounds(): InputBounds {
  return { min: 0, max: 0 };
}

export const InputBounds: MessageFns<InputBounds> = {
  encode(message: InputBounds, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== 0) {
      writer.uint32(13).float(message.min);
    }
    if (message.max !== 0) {
      writer.uint32(21).float(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputBounds {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputBounds();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.min = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.max = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputBounds {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
    };
  },

  toJSON(message: InputBounds): unknown {
    const obj: any = {};
    if (message.min !== 0) {
      obj.min = message.min;
    }
    if (message.max !== 0) {
      obj.max = message.max;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputBounds>, I>>(base?: I): InputBounds {
    return InputBounds.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputBounds>, I>>(object: I): InputBounds {
    const message = createBaseInputBounds();
    message.min = object.min ?? 0;
    message.max = object.max ?? 0;
    return message;
  },
};

function createBaseInputViewBox(): InputViewBox {
  return { latBounds: undefined, lngBounds: undefined };
}

export const InputViewBox: MessageFns<InputViewBox> = {
  encode(message: InputViewBox, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latBounds !== undefined) {
      InputBounds.encode(message.latBounds, writer.uint32(10).fork()).join();
    }
    if (message.lngBounds !== undefined) {
      InputBounds.encode(message.lngBounds, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputViewBox {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputViewBox();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.latBounds = InputBounds.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lngBounds = InputBounds.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputViewBox {
    return {
      latBounds: isSet(object.latBounds) ? InputBounds.fromJSON(object.latBounds) : undefined,
      lngBounds: isSet(object.lngBounds) ? InputBounds.fromJSON(object.lngBounds) : undefined,
    };
  },

  toJSON(message: InputViewBox): unknown {
    const obj: any = {};
    if (message.latBounds !== undefined) {
      obj.latBounds = InputBounds.toJSON(message.latBounds);
    }
    if (message.lngBounds !== undefined) {
      obj.lngBounds = InputBounds.toJSON(message.lngBounds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputViewBox>, I>>(base?: I): InputViewBox {
    return InputViewBox.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputViewBox>, I>>(object: I): InputViewBox {
    const message = createBaseInputViewBox();
    message.latBounds = (object.latBounds !== undefined && object.latBounds !== null)
      ? InputBounds.fromPartial(object.latBounds)
      : undefined;
    message.lngBounds = (object.lngBounds !== undefined && object.lngBounds !== null)
      ? InputBounds.fromPartial(object.lngBounds)
      : undefined;
    return message;
  },
};

function createBaseInputPolygonColor(): InputPolygonColor {
  return { color: "", opacity: 0 };
}

export const InputPolygonColor: MessageFns<InputPolygonColor> = {
  encode(message: InputPolygonColor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.color !== "") {
      writer.uint32(10).string(message.color);
    }
    if (message.opacity !== 0) {
      writer.uint32(21).float(message.opacity);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputPolygonColor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputPolygonColor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.color = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.opacity = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputPolygonColor {
    return {
      color: isSet(object.color) ? globalThis.String(object.color) : "",
      opacity: isSet(object.opacity) ? globalThis.Number(object.opacity) : 0,
    };
  },

  toJSON(message: InputPolygonColor): unknown {
    const obj: any = {};
    if (message.color !== "") {
      obj.color = message.color;
    }
    if (message.opacity !== 0) {
      obj.opacity = message.opacity;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputPolygonColor>, I>>(base?: I): InputPolygonColor {
    return InputPolygonColor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputPolygonColor>, I>>(object: I): InputPolygonColor {
    const message = createBaseInputPolygonColor();
    message.color = object.color ?? "";
    message.opacity = object.opacity ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
